/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Field, Form as Formikform, Formik } from 'formik';
import Layout from 'components/Layout';
import SubTitle from 'components/SubTitle';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import CheckBox from 'components/Form/CheckBox';
import { Col, Row } from 'components/Grid';
import { SelectField } from "components/Form";
import { FitinsurAPI, MessageCenter } from 'utils';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import DialogComponent from "components/Dialog";
import Icon from 'components/Icon';
import { FontWeight } from 'components/Text';
import Colors from 'constants/Colors';
import Loader from 'components/Loader/index';
import { ButtonContent, DialogCancel, DialogConfirm, DialogSelect, Line, Scrollbox, Text, Title } from './styles';
import RenderButtons from 'components/RenderButtons';

export default function SelectMarketsMasterPolicy(props) {
	const [summary, setSummary] = useState({});
	const [sortList, setSortList] = useState([]);
	const [data, setData] = useState([]);
	const [filter, setFilter] = useState(
		{
			key: null,
			direction: null,
		}
	);
	const coluns = [
		{
			title: "INSURER",
			value: "nmInsurer"
		},
		{
			title: "MAXIMUM LIMIT (USD)",
			value: "maxLimit"
		},
		{
			title: "MAXIMUM TENOR (YEARS)",
			value: "maxTenorDays"
		},
		{
			title: "APPROVED",
			value: "ndaStatus"
		},
	];
	const [selectedItems, setSelectedItems] = useState([]);
	const loading = useContext(GlobalLoaderContext);
	const fitinsur = new FitinsurAPI();
	const mc = new MessageCenter();
	const history = useHistory();
	const authContext = useContext(GlobalAuthContext);
	const [isEndorsment, setIsEndorsment] = useState(false);
	const [endorsmentType, setEndorsmentType] = useState("");
	const [previousItems, setPreviousItems] = useState([]);
	const [idDomainStatusNBI, setIdDomainStatusNBI] = useState(null);

	const goToLoginPage = () => {
		history.push('/login');
	};

	const [lostDeal, setLostDeal] = useState({
		formated: [],
		array: [],

	});

	const [dialog, setDialog] = useState({
		visible: false,
		title: "",
		icon: "times-circle",
		args: null,
	});

	const requestLostDealList = () => {
		fitinsur.setAuthToken(authContext.token);
		fitinsur.requestLostDealList()
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.ret_code != 200) {
					mc.error(data.ret_msg_details);
					history.goBack();
					return;
				}
				if (data.ret_value.length >= 1) {
					const lista = [];
					for (let index = 0; index < data.ret_value.length; index++) {
						lista.push({ label: data.ret_value[index].ANSWER_OPTION_DESCRIPTION, value: data.ret_value[index].ID_ANSWER_OPTION })
					}
					setLostDeal({ formated: lista, array: data.ret_value });
				} else {
					setLostDeal({ formated: [{ label: 'Error', value: '' }], array: [] });
				}
			})
			.catch((error) => {
				mc.error(`There was an error while fetching your data: ${requestLostDealList.name}\n` + error);
				console.error('fitGetLostReason - Error:', error);
				setLostDeal({ formated: [{ label: 'Error', value: '' }], array: [] });
			});
	}

	const HandleLostSubmit = (selectedID, array, argsContext) => {
		console.log(selectedID, array, argsContext);
		fitinsur.setAuthToken(authContext.token);
		fitinsur.updateQuoteEdit(props.match.params.idOperation, selectedID.reasons).then(x => x.json()).then(res => {
			console.log(res)
			if (res.ret_code != 200) {
				mc.error(res.ret_msg_details);
				return;
			}
			setDialog({ visible: false, title: null, icon: null, args: null });
			history.push('/list');
		})
	};

	useMemo(() => {
		setSortList(data);
		if (filter !== null) {
			sortList.sort((a, b) => {
				if (a[filter.key] < b[filter.key]) {
					return filter.direction === 'asc' ? -1 : 1;
				} else if (a[filter.key] > b[filter.key]) {
					return filter.direction === 'asc' ? 1 : -1;
				}
				return 0;
			})
		} else {
			return;
		}

	}, [filter, data]);

	useEffect(() => {
		if (authContext.status !== true) {
			mc.error("User is not authenticated, please Login");
			loading.stop();
			goToLoginPage();
			return;
		}
		else {
			fitinsur.setAuthToken(authContext.token);
			loading.stop();
		}

		function handleGetNbiStatus(queryString) {
			fitinsur.setAuthToken(authContext.token);
			fitinsur.requestMarketsResponse(props.match.params.idOperation)
				.then(response => response.json())
				.then(data => {
					if (data.ret_code != 200) {
						return;
					}

					setIdDomainStatusNBI(data.ret_value.idDomainStatusNBI)

				})
		};

		async function handleList() {
			loading.start();
			fitinsur.setAuthToken(authContext.token);
			fitinsur.requestListMarkets(props.match.params.idOperation).then((response) => {
				response.json().then((res) => {
					loading.stop();

					if (res.ret_code != 200) {
						mc.error(res.ret_msg_details);
						history.goBack();
						return;
					}
					let ids = [];
					res.ret_value.forEach((e) => {
						for (const le of e.legalEntities) {
							if (le.existLegalEntity) {
								ids.push(le.idPerson);
							}
						}
					});
					handleSelect(null, ids);
					setPreviousItems(ids);
					console.log(selectedItems);
					setData(res.ret_value)
				})
			}).catch((error) => {
				loading.stop();
				mc.error(`There was an error while fetching your data: ${handleList.name}\n` + error);
				console.error('fitPostList - Error:', error);
			});
		}

		handleSummary();
		handleList();
		handleGetNbiStatus();
	}, []);

	useEffect(() => {
		setSortList(data);
	}, [data]);

	function handleSummary() {
		fitinsur.setAuthToken(authContext.token);
		fitinsur.requestHeaderNbi(props.match.params.idOperation)
			.then(response => response.json()).then(data => {
				console.log("Sumario-> ", data.ret_value)
				if (data.ret_code != 200) {
					mc.error(data.ret_msg_details);
					history.goBack();
					return;
				}
				setSummary({
					typeOfCover: data.ret_value.typeOfCover,
					client: data.ret_value.client,
					obligorCoding: data.ret_value.obligorCoding,
					responseBy: data.ret_value.responseBy,
					internalContact: data.ret_value.internalContact,
					broker: data.ret_value.broker,
					dealCode: data.ret_value.deal,
					nmFacility: data.ret_value.nmFacility,
					projectName: data.ret_value.projectName,
					nmObligor: data.ret_value.nmObligor
				});
				setEndorsmentType(data.ret_value.endorsmentType);
				setIsEndorsment(!!data.ret_value.endorsmentType);
			})
			.catch((error) => {
				mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
				console.error('fitPostSummary - Error:', error);
			});
	}

	function handleSubmit() {
		loading.start();
		fitinsur.setAuthToken(authContext.token);

		fitinsur.requestSelectMarkets(props.match.params.idOperation, selectedItems, true)
			.then(response => response.json())
			.then(data => {
				if (data.ret_code === 200) {
					if (isEndorsment) {
						loading.stop();
						history.push(`/broking/contacts-selection/${props.match.params.idOperation}`, { idProduct: 16 });
					} else {
						loading.stop();
						history.push(`/broking/payment-pack-configuration/${data.ret_value}`);
					}
				} else {
					loading.stop();
					mc.error(data.ret_msg_details);
				}
			})
			.catch((error) => {
				loading.stop();
				mc.error("There was an error while fetching your data:  \n" + error);
				console.error('fitPostSubmit - Error:', error);
			});
	}

	function handleSortList(key) {
		let direction = 'asc';
		if (filter.key === key && filter.direction === 'asc') {
			direction = 'desc';
		};
		setFilter({ key: key, direction: direction });
	};

	function handleDialog() {
		setDialog({
			visible: true,
			title: "LOST DEAL",
			icon: "TimesCircle",
			args: null,
		})
		requestLostDealList();
	};

	function handleSelect(e, ids = []) {
		if (ids.length >= 1) {
			setSelectedItems([...selectedItems, ...ids]);
			return
		}
		const alreadySelected = selectedItems.findIndex((item) => item === e.idPerson);
		if (alreadySelected >= 0) {
			const filteredItems = selectedItems.filter((item) => item !== e.idPerson);
			setSelectedItems(filteredItems);
		} else {
			if (e) {
				setSelectedItems([...selectedItems, e.idPerson]);
			}

		};
	};

	function handleBack() {
		history.goBack();
	}

	return (
		<Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"}>
			<SubTitle stage={2} info={{ idOperation: props.match?.params?.idOperation || null }} />
			<Scrollbox>
				<BrokingSummary data={summary} />
				<ContentCard title={endorsmentType && endorsmentType === 'risk_changes' ? "Risk & Market Changes / SELECT MARKETS" : "SELECT MARKETS"} icon info={{ idOperation: props.match?.params?.idOperation || null }}>
					<DialogComponent
						icon={dialog.icon}
						title={dialog.title}
						
						show={dialog.visible}
						setDialog={setDialog}
					>
						<Formik
							initialValues={{ reasons: "" }}
							onSubmit={(e) => HandleLostSubmit(e, lostDeal.array, dialog.args)}
						>
							<Formikform>
								<DialogSelect>
									<Field
										name="reasons"
										placeholder="Select the reason the deal was lost"
										component={SelectField}
										options={lostDeal.formated}
									/>
								</DialogSelect>

								<DialogCancel
									onClick={() => {
										setDialog({
											visible: false,
											title: null,
											icon: null,
											args: null,
										});
									}}
								>
									Cancel
								</DialogCancel>
								<DialogConfirm type="submit">Confirm</DialogConfirm>
							</Formikform>
						</Formik>
					</DialogComponent>

					<Row style={{ paddingBottom: "15px" }}>
						{coluns ? coluns.map((colun, index) =>
							<Col key={index} >
								<Text
									onClick={() => handleSortList(colun.value)}
								>
									{colun.title}
								</Text>

								{filter.key === colun.value && filter.direction === "asc" ?
									<Icon name="arrowUp" className="icon-arrowUp" />
									: <Icon name="arrowDown" className="arrowDown" />}
							</Col>
						)
							: ""}
						<Col style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
							<Text>SELECT</Text>
						</Col>
					</Row>

					{!sortList ? "" : sortList.map((item, index) => {
						if (isEndorsment && previousItems.find(idPerson => item.legalEntities?.find(itemEntities => itemEntities.idPerson === idPerson))) return <></>;

						return (<>
							<Row key={index} style={{ marginTop: "10px", fontWeight: `${FontWeight.SemiBold}`, color: `${Colors.GRAY[0]}` }}>
								<Col style={{ display: "flex", justifyContent: "flex-start" }}>
									<Title>{item.PERSON_FIRST_NAME}</Title>
								</Col>
							</Row>
							{!item.legalEntities ? "" : item.legalEntities.map((itemEntities, indexEntities) =>

							(<>
								<Row key={indexEntities} style={{ marginTop: "10px", fontWeight: `${FontWeight.SemiBold}`, color: `${Colors.GRAY[0]}` }}>
									<Col style={{ display: "flex", justifyContent: "flex-start" }}>
										{itemEntities.personLastName}
									</Col>

									<Col >
										{item.coverages[0]?.maxLimit}
									</Col>
									<Col >
										{(parseInt(item.coverages[0]?.maxTenorYears || 0)).toFixed(0)}
									</Col>
									<Col >
										{item.ndaStatus ? "YES" : "NO"}
									</Col>

									<Col style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
										<label >
											<CheckBox
												checked={selectedItems.includes(itemEntities.idPerson)}
												onChange={() => { handleSelect(itemEntities) }}
											/>
										</label>
									</Col>
								</Row>
								<Line />
							</>)
							)}
							<Line />
						</>)
					})}
					<ButtonContainer>
						<Button forth onClick={() => handleBack()}>&lt; Back</Button>
						<RenderButtons idOperation={props.match?.params?.idOperation}>
							<ButtonContent>
								<Button
									secundary
									type="submit"
									name="Lost"
									id="btnLost"
									style={{ marginLeft: "10px", marginTop: "5px" }}
									onClick={() => handleDialog()}>
									LOST</Button>
								<Button
									primary
									type="submit"
									onClick={() => handleSubmit()} style={{ marginLeft: "10px", marginTop: "5px" }}
									disabled={idDomainStatusNBI === 19}
								>
									SUBMIT
								</Button>
							</ButtonContent>
						</RenderButtons>
					</ButtonContainer>
				</ContentCard>
			</Scrollbox >
			{loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
		</Layout >
	)
}
